export const referenceDimensions = frames => {
  const images = frames.map(frame => frame.image).filter(Boolean)
  const match = images.find(image => (image.dimensions || []).length)
  return match && match.dimensions
}

const matchesDimensions = (image, reference) => {
  if (!reference) return true
  const dimensions = (image && image.dimensions) || []
  return dimensions[0] === reference[0] && dimensions[1] === reference[1]
}

export const formatDimensions = frames => {
  const dimensions = referenceDimensions(frames)
  if (!dimensions) return
  return `${dimensions[0]} x ${dimensions[1]} px`
}

export const markByDimensions = (uploaded, reference) => {
  let base = reference
  let rejected = 0

  const images = uploaded.map(image => {
    if (!base) {
      base = image.dimensions
      return image
    }

    if (matchesDimensions(image, base)) return image

    rejected++
    return null
  })

  return { images, rejected, reference: base }
}
